import * as React from 'react';

function SvgCheckBigIcon(props) {
  return (
    <svg
      data-name="Check Big Icon"
      id="check_big_icon__1"
      width={props.size || 22.508}
      height={props.size || 17.477}
      viewBox="0 0 22.508 17.477"
      xmlSpace="preserve"
      {...props}
    >
      <path
        d="M8.619 17.141a1.149 1.149 0 01-1.625 0l-6.489-6.49a1.723 1.723 0 010-2.437l.812-.813a1.723 1.723 0 012.438 0l4.051 4.051L18.753.505a1.723 1.723 0 012.438 0l.809.813a1.723 1.723 0 010 2.437zm0 0"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgCheckBigIcon;
